import axios from "../services/api/api";

export function fetchStudentProfileAction() {
  return function(dispatch) {
    dispatch({
      type: "FETCH_STUDENT_PROFILE_BEGIN",
      payload: { loading: true }
    });
    axios
      .get("/student/MyResult")
      .then(response => {
        dispatch({
          type: "FETCH_STUDENT_PROFILE_SUCCESS",
          payload: response.data.result
        });
      })
      .catch(err => {
        dispatch({ type: "FETCH_STUDENT_PROFILE_REJECTED", payload: err });
      });
  };
}
